<template>
    <b-modal
        v-model="modalForm.isOpen"
        title="Variables configurables"
        hide-footer
        size="lg"
    >

        <!-- Formulario -->
        <form @submit.prevent="onHandleStoreConfigurableVariable" data-vv-scope="configurableVariableForm">

            <b-row>

                <!-- Listas (Idiomas disponibles) -->
                <b-col md="6" sm="12">
                    <label for="configurableVariable_sys_list_id" class=" mb-1">Seleccionar Idioma (*)</label>
                    <el-select
                        v-model="configurableVariable.sys_list_id"
                        filterable
                        clearable
                        no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan"
                        id="configurableVariable_sys_list_id"
                        name="configurableVariable_sys_list_id"
                        data-vv-as=" "
                        v-validate="'required'"
                    >
                        <el-option
                        v-for="language in languages"
                        :key="language.id"
                        :label="language.lista"
                        :value="language.id"
                        >
                        </el-option>
                    </el-select>
                    <div class="text-danger span-error small" v-text="errors.first('configurableVariableForm.configurableVariable_sys_list_id')" />
                </b-col>

                <!-- Países -->
                <b-col md="6" sm="12">
                    <label for="configurableVariable_slq_country_id" class=" mb-1">Seleccionar País (*)</label>
                    <el-select
                        v-model="configurableVariable.slq_country_id"
                        filterable
                        clearable
                        no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan"
                        id="configurableVariable_slq_country_id"
                        name="configurableVariable_slq_country_id"
                        data-vv-as=" "
                        v-validate="'required'"
                        @change="onHandleChangeCountry($event)"
                    >
                        <el-option
                        v-for="country in countries"
                        :key="country.id"
                        :label="`${country.name} (${country.code})`"
                        :value="country.id"
                        >
                        </el-option>
                    </el-select>
                    <div class="text-danger span-error small" v-text="errors.first('configurableVariableForm.configurableVariable_slq_country_id')" />
                </b-col>

            </b-row>

            <!-- Teléfono -->
            <b-row class="mt-3">

                <b-col md="6" sm="12">
                    <b-row>
                        <b-col cols="4">
                            <b-form-group>
                                <label for="configurableVariable_phone" class="w-100 mb-1">Indicativo</label>
                                <b-form-input
                                    type="text"
                                    id="configurableVariable_phone_code"
                                    name="configurableVariable_pphone_code"
                                    v-model="configurableVariable.phone_code"
                                    data-vv-as=" "
                                    placeholder="+57"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="8">
                            <b-form-group>
                                <label for="configurableVariable_phone" class="w-100 mb-1">Ingrese un Teléfono de emergencia (*)</label>
                                <b-form-input
                                    type="text"
                                    id="configurableVariable_phone"
                                    name="configurableVariable_phone"
                                    v-model="configurableVariable.phone"
                                    data-vv-as=" "
                                    v-validate="'required|max:30|min:1'"
                                    placeholder="(xxx) xxx-xxxx"
                                />
                                <div class="text-danger span-error small" v-text="errors.first('configurableVariableForm.configurableVariable_phone')" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>

                <!-- <b-col md="6" sm="12" v-if="!getAction">
                    <b-form-group>
                        <label for="configurableVariable_phone" class="w-100 mb-1">Defina un estado</label>


                        <div class="d-flex align-items-center justify-content-start">
                            <div class="checkbox-wrapper-20">
                                <div class="switch">
                                    <input id="toggle-check-status-store" class="input" type="checkbox" v-model="configurableVariable.is_active" />
                                    <label for="toggle-check-status-store" class="slider mb-0"></label>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-col> -->

            </b-row>

            <!-- footer -->
            <b-row class="mt-4 d-flex align-items-center justify-content-end">
                <b-button variant="secondary" @click.prevent="onHandleCancelStoreConfigurableVariable">
                    <i class="fa fa-close mr-1" />
                    Cancelar
                </b-button>
                <b-button class="mr-3 ml-2" type="submit" variant="primary" @click.prevent="onHandleStoreConfigurableVariable">
                    <i class="fa mr-1" :class="{ 'fa-save': getAction, 'fa-edit': !getAction }" />
                    {{ getAction ? 'Crear variable' : 'Guardar cambios' }}
                </b-button>
            </b-row>

        </form>

    </b-modal>
</template>

<script>

// Importaciones generales
import { mapMutations, mapState, mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
    name: 'ModalFormConfigurableVariables',
    data() {
        return { }
    },
    computed: {
        // Estados del modulo Empresas
        ...mapState('empresa', [
            'selectedEmpresa'
        ]),
        // Estados del modulo variables configurables.
        ...mapState('configurableVariables', [
            'modalForm',
            'configurableVariable',
            'filter'
        ]),
        // Estados del modulo Listas
        ...mapState('sysList', {
            languages: 'lists'
        }),
        // Estados del modulo Países
        ...mapState('countries', ['countries']),
        /**
         * Obtener la acción actual.
         * @author Fernando Claros
         */
        getAction() {
            return this.modalForm.action === 'CREATE' ? true : false;
        }
    },
    methods: {
        // Mutaciones del modulo variables configurables.
        ...mapMutations('configurableVariables', [
            'setModalForm',
            'setDefaultConfigurableVariable',
            'setConfigurableVariable'
        ]),
        // Acciones del modulo variables configurables.
        ...mapActions('configurableVariables', [
            'storeConfigurableVariable',
            'updateConfigurableVariable'
        ]),
        /**
         * Crear/Editar variables configurables.
         *
         * @author Fernando Claros
         */
        async onHandleStoreConfigurableVariable() {
            await this.$validator.validateAll('configurableVariableForm')
                .then(async isValid => {
                    if (!isValid) return;

                    const payload = {
                        ...this.configurableVariable,
                        slq_company_id: this.selectedEmpresa.id,
                        is_active: this.configurableVariable.is_active ? 1 : 0,
                        page: this.filter.page,
                        status: 'ALL'
                    }

                    if (this.modalForm.action === 'CREATE') this.storeConfigurableVariable(payload)
                    else this.updateConfigurableVariable(payload)
                })
        },
        /**
         * Cancelar acción de crear/editar variables configurables.
         *
         * @author Fernando Claros
         */
        onHandleCancelStoreConfigurableVariable() {
            this.setDefaultConfigurableVariable();
            this.setModalForm({
                isOpen: false,
                action: 'CREATE'
            });
        },
        /**
         * Cambiar de país sleccionado.
         *
         * @author Fernando Claros
         */
        onHandleChangeCountry(selectedCountryId) {
            const country = this.countries.find(x => x.id === selectedCountryId);

            if (country && country.phone_code) {

                if (this.configurableVariable.phone_code) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Variables configurables',
                        text: 'El país seleccionado tiene un prefijo propio, ¿desea utilizarlo.?',
                        showDenyButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Si, utilizar prefijo del País.',
                        cancelButtonText: 'No, usar prefijo actual.',
                    }).then(result => {
                        if (result.isConfirmed) this.configToUseCustomizedPhoneCode(country.phone_code);
                    })
                    return false;
                }
                else this.configToUseCustomizedPhoneCode(country.phone_code);
            }
        },
        /**
         * Usar el prefijo predefinido por el usuario.
         *
         * @author Fernando Claros
         */
        configToUseCustomizedPhoneCode(phoneCode) {
            this.setConfigurableVariable({ ...this.configurableVariable, phone_code: phoneCode });
        }
    }
};
</script>

<style scoped></style>
